import { Link } from "react-router-dom";

/** Shown when a new app is refused because the plan's app limit is reached (C6). */
export function AppLimitReachedNotice({ isAdmin }: { isAdmin: boolean }) {
  return (
    <div role="alert" className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-950">
      <p className="font-semibold">現在のプランで登録できるアプリ数に達しています</p>
      {isAdmin ? (
        <p className="mt-1">
          アプリ数の多いプランに変えると、続けて登録できます。
          <Link to="/console/service-subscription" className="ml-1 font-medium text-primary underline">上位プランの料金を見る</Link>
        </p>
      ) : (
        <p className="mt-1">アプリを追加するには、組織の管理者にプランの変更を依頼してください。</p>
      )}
    </div>
  );
}
